import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { locations } from '@/locations';
import { useAuth } from '@/providers/AuthProvider';
import { useDispatch } from 'react-redux';
import { diagnosticApi } from '@/store/api/diagnosticApi';
import { userApi } from '@/store/api/userApi';
import { analytics } from '@/analytics';
import { notificationApi } from '@/store/api/notificationApi';
import { resetAllFilters, resetAllSearch } from '@/store/slices/assetsPreviewSlice';

export const Logout = ({ children }: any) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { signOut } = useAuth();

  const [startLoggingOut, setStartLoggingOut] = useState(false);

  const logoutUser = async () => {
    try {
      await signOut();
      dispatch(userApi.util.resetApiState());
      dispatch(diagnosticApi.util.resetApiState());
      dispatch(notificationApi.util.resetApiState());
      dispatch(userApi.util.resetApiState());
      dispatch(resetAllSearch());
      dispatch(resetAllFilters());

      navigate(locations.public.login);
      analytics.track('User logged out');
    } catch (error: unknown) {
      setStartLoggingOut(false);
    }
  };

  useEffect(() => {
    if (startLoggingOut) {
      logoutUser();
    }
  }, [startLoggingOut]);

  const onLogoutClick = () => {
    setStartLoggingOut(true);
  };

  return (
    <div className="cursor-pointer" onClick={onLogoutClick}>
      {children}
    </div>
  );
};
